import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "../service/tekkr-service";

interface SetupOptions {
    onSuccess?: (data: { sourceConfigId: string; jobId: string; pickerUrl?: string }) => void;
}

export function useSetupGoogleDriveMutation(options?: SetupOptions) {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (params: {
            storageLevel: "full" | "summary" | "reference";
            accessMode?: "full" | "restricted";
        }) => {
            const res = await apiClient.setupGoogleDrive({
                body: { storageLevel: params.storageLevel, accessMode: params.accessMode },
            });
            if (res.status !== 200) {
                throw new Error("Failed to setup Google Drive");
            }
            return res.body;
        },
        onSuccess: async (data) => {
            await queryClient.invalidateQueries({ queryKey: ["google-drive-status"] });
            options?.onSuccess?.(data);
        },
    });
}

interface DeleteOptions {
    onSuccess?: () => void;
}

export function useDeleteGoogleDriveMutation(options?: DeleteOptions) {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async () => {
            const res = await apiClient.deleteGoogleDrive();
            if (res.status !== 200) {
                throw new Error("Failed to delete Google Drive");
            }
            return res.body;
        },
        onSuccess: async () => {
            await queryClient.invalidateQueries({ queryKey: ["google-drive-status"] });
            options?.onSuccess?.();
        },
    });
}
